import { useTheme } from '@mui/system';
import React from 'react';
import { JSONTree } from 'react-json-tree';

interface JobParamsJsonTreeProps {
  data: unknown;
}

export const JobParamsJsonTree = ({ data }: JobParamsJsonTreeProps) => {
  const theme = useTheme();

  return (
    <JSONTree
      data={data || {}}
      theme={{
        extend: {
          scheme: 'app',
          author: 'NucleAI',
          base00: 'transparent',
          base01: theme.palette.action.hover,
          base02: theme.palette.divider,
          base03: theme.palette.text.disabled,
          base04: theme.palette.text.secondary,
          base05: theme.palette.text.primary,
          base06: theme.palette.text.primary,
          base07: theme.palette.text.primary,
          base08: theme.palette.warning.main,
          base09: theme.palette.secondary.main,
          base0A: theme.palette.text.disabled,
          base0B: theme.palette.text.primary,
          base0C: theme.palette.secondary.light,
          base0D: theme.palette.text.secondary,
          base0E: theme.palette.secondary.main,
          base0F: theme.palette.warning.light,
        },
        arrowSign: { color: theme.palette.secondary.main },
      }}
      invertTheme={false}
      labelRenderer={([key]) => <strong>{key}:</strong>}
      getItemString={(_type, _data, itemType, itemString) => (
        <span style={{ color: theme.palette.info?.main ?? '#29b6f6' }}>
          {itemType} {itemString}
        </span>
      )}
    />
  );
};
